import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import config from "@/lib/config";
import { RESTDataSource } from "@apollo/datasource-rest";
import { v4 as uuidv4 } from "uuid";
class SessionManager extends RESTDataSource {
  constructor(options) {
    super(options);
    _defineProperty(this, "baseURL", config.api.vcmsURL);
    this.context = options;
  }
  willSendRequest(_path, request) {
    var _this$context$req;
    if ((_this$context$req = this.context.req) !== null && _this$context$req !== void 0 && _this$context$req.userToken) {
      const {
        id,
        accessToken
      } = this.context.req.userToken;
      request.headers["X-Token-Id"] = id;
      request.headers["Authorization"] = `Bearer ${accessToken}`;
    }
    const requestId = uuidv4();
    request.headers["X-Spoox-Web-Session-Request-Id"] = requestId;
    const userId = request.headers["X-Token-Id"];
    console.log(`[${requestId}][Session][REQUEST INFO] Method: ${request.method}, Path: ${_path}, UserId: ${userId}`);
  }
  async didReceiveResponse(response, request) {
    const requestId = request.headers["X-Spoox-Web-Session-Request-Id"];
    console.log(`[${requestId}][Session][RESPONSE INFO] Status: ${response.status}`);
    return super.didReceiveResponse(response, request);
  }
  async pinActivate() {
    // TVデバイスのアクティベーションコードの認証
    // this.post("/pin/activate")
  }
  async tokenRefresh() {
    var _this$context$req2;
    if ((_this$context$req2 = this.context.req) !== null && _this$context$req2 !== void 0 && _this$context$req2.userToken) {
      const {
        refreshToken
      } = this.context.req.userToken;
      const params = {
        refresh_token: refreshToken
      };
      const ret = await this.post("/api/v1/token/refresh", {
        body: params
      });
      return ret;
    }
  }
  async tokenCheck() {
    return this.post("/api/v1/token/check");
  }
  async tokenDelete() {
    return this.post("/api/v1/token/delete");
  }
  async tokenDeleteOther() {
    return this.post("/api/v1/token/delete-other");
  }
  async onetimeToken() {
    return this.post("/api/v1/ontime-token/publish");
  }
}
export default SessionManager;